import { render, staticRenderFns } from "./bigEquity.vue?vue&type=template&id=81153292&scoped=true&"
import script from "./bigEquity.vue?vue&type=script&lang=js&"
export * from "./bigEquity.vue?vue&type=script&lang=js&"
import style0 from "./bigEquity.vue?vue&type=style&index=0&id=81153292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81153292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
